import {Component, OnInit} from "@angular/core";
import {CommonModule} from "@angular/common";
import {DestroyableBase, PropertyPublicDashboardApiService} from "../../../../lib";
import {DashboardService} from "../../dashboard.service";
import {distinctUntilKeyChanged, switchMap} from "rxjs/operators";
import {DashboardModuleButtonType, SubscriberBasicInfo} from "fello-model";
import {PhonePipe} from "../../../fello-ui-utils";

@Component({
  selector: "lib-subscriber-info",
  standalone: true,
  imports: [CommonModule, PhonePipe],
  templateUrl: "./subscriber-info.component.html",
  styleUrls: ["./subscriber-info.component.scss"]
})
export class SubscriberInfoComponent extends DestroyableBase implements OnInit {
  subscriberInfo: SubscriberBasicInfo | null = null;

  constructor(private publicDashboardApiService: PropertyPublicDashboardApiService, private dashboardService: DashboardService) {
    super();
  }

  ngOnInit(): void {
    this.dashboardService.property$
      .pipe(
        distinctUntilKeyChanged("propertyId"),
        switchMap(property => this.publicDashboardApiService.getContactPotentialSubscriberInfo(property.propertyId))
      )
      .subscribe(subscriberInfo => {
        this.subscriberInfo = subscriberInfo;
      });
  }

  protected readonly DashboardModuleButtonType = DashboardModuleButtonType;
}
